import { render, staticRenderFns } from "./itemsValoracionShow.vue?vue&type=template&id=55fc63e2&scoped=true"
import script from "./itemsValoracionShow.vue?vue&type=script&lang=js"
export * from "./itemsValoracionShow.vue?vue&type=script&lang=js"
import style0 from "./itemsValoracionShow.vue?vue&type=style&index=0&id=55fc63e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55fc63e2",
  null
  
)

export default component.exports